const ICON_COMMON = {
  add: 'fi fi-rr-plus',
  edit: 'fi fi-rr-edit',
  view: 'fi fi-rr-eye',
  trash: 'fi fi-rr-trash',
};
export default ICON_COMMON;
